import * as $ from "jquery";

export function activateAdjustContainerHeight() {

    $(document).ready(function() {

        function adjustContainerHeight() {
            // Prüfen, ob body die Klasse 'be-layout-home' hat
            if ($('body').hasClass('be-layout-home')) {
//                if ($(window).height() < 1005) {
                    $('html, body').animate({ scrollTop: $(document).height() }, 1, function() {
                        $('html, body').animate({ scrollTop: 0 }, 2);
                    });
//                }
            }
        }
    
        adjustContainerHeight();
    
    });


}
